import _slicedToArray from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toArray from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _classCallCheck from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var n = /[^\0-\x7E]/;
var t = /[\x2E\u3002\uFF0E\uFF61]/g;
var o = {
  overflow: "Overflow Error",
  "not-basic": "Illegal Input",
  "invalid-input": "Invalid Input"
};
var e = Math.floor;
var r = String.fromCharCode;

function s(n2) {
  throw new RangeError(o[n2]);
}

var c = function c(n2, t2) {
  return n2 + 22 + 75 * (n2 < 26) - ((t2 != 0) << 5);
};

var u = function u(n2, t2, o2) {
  var r2 = 0;

  for (n2 = o2 ? e(n2 / 700) : n2 >> 1, n2 += e(n2 / t2); n2 > 455; r2 += 36) {
    n2 = e(n2 / 35);
  }

  return e(r2 + 36 * n2 / (n2 + 38));
};

function toASCII(o2) {
  return function (n2, o3) {
    var e2 = n2.split("@");
    var r2 = "";
    e2.length > 1 && (r2 = e2[0] + "@", n2 = e2[1]);

    var s2 = function (n3, t2) {
      var o4 = [];
      var e3 = n3.length;

      for (; e3--;) {
        o4[e3] = t2(n3[e3]);
      }

      return o4;
    }((n2 = n2.replace(t, ".")).split("."), o3).join(".");

    return r2 + s2;
  }(o2, function (t2) {
    return n.test(t2) ? "xn--" + function (n2) {
      var t3 = [];

      var o3 = (n2 = function (n3) {
        var t4 = [];
        var o4 = 0;
        var e2 = n3.length;

        for (; o4 < e2;) {
          var r2 = n3.charCodeAt(o4++);

          if (r2 >= 55296 && r2 <= 56319 && o4 < e2) {
            var e3 = n3.charCodeAt(o4++);
            (64512 & e3) == 56320 ? t4.push(((1023 & r2) << 10) + (1023 & e3) + 65536) : (t4.push(r2), o4--);
          } else {
            t4.push(r2);
          }
        }

        return t4;
      }(n2)).length;

      var f = 128;
      var i = 0;
      var l = 72;

      var _iterator = _createForOfIteratorHelper(n2),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _o = _step.value;
          _o < 128 && t3.push(r(_o));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var h = t3.length;
      var p = h;

      for (h && t3.push("-"); p < o3;) {
        var o4 = 2147483647;

        var _iterator2 = _createForOfIteratorHelper(n2),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var t4 = _step2.value;
            t4 >= f && t4 < o4 && (o4 = t4);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var a = p + 1;
        o4 - f > e((2147483647 - i) / a) && s("overflow"), i += (o4 - f) * a, f = o4;

        var _iterator3 = _createForOfIteratorHelper(n2),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var o5 = _step3.value;

            if (o5 < f && ++i > 2147483647 && s("overflow"), o5 == f) {
              var n3 = i;

              for (var o6 = 36;; o6 += 36) {
                var s2 = o6 <= l ? 1 : o6 >= l + 26 ? 26 : o6 - l;

                if (n3 < s2) {
                  break;
                }

                var u2 = n3 - s2;
                var f2 = 36 - s2;
                t3.push(r(c(s2 + u2 % f2, 0))), n3 = e(u2 / f2);
              }

              t3.push(r(c(n3, 0))), l = u(i, a, p == h), i = 0, ++p;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        ++i, ++f;
      }

      return t3.join("");
    }(t2) : t2;
  });
}

var HASH_RE = /#/g;
var AMPERSAND_RE = /&/g;
var SLASH_RE = /\//g;
var EQUAL_RE = /=/g;
var IM_RE = /\?/g;
var PLUS_RE = /\+/g;
var ENC_BRACKET_OPEN_RE = /%5B/gi;
var ENC_BRACKET_CLOSE_RE = /%5D/gi;
var ENC_CARET_RE = /%5E/gi;
var ENC_BACKTICK_RE = /%60/gi;
var ENC_CURLY_OPEN_RE = /%7B/gi;
var ENC_PIPE_RE = /%7C/gi;
var ENC_CURLY_CLOSE_RE = /%7D/gi;
var ENC_SPACE_RE = /%20/gi;
var ENC_SLASH_RE = /%2F/gi;
var ENC_ENC_SLASH_RE = /%252F/gi;

function encode(text) {
  return encodeURI("" + text).replace(ENC_PIPE_RE, "|").replace(ENC_BRACKET_OPEN_RE, "[").replace(ENC_BRACKET_CLOSE_RE, "]");
}

function encodeHash(text) {
  return encode(text).replace(ENC_CURLY_OPEN_RE, "{").replace(ENC_CURLY_CLOSE_RE, "}").replace(ENC_CARET_RE, "^");
}

function encodeQueryValue(text) {
  return encode(text).replace(PLUS_RE, "%2B").replace(ENC_SPACE_RE, "+").replace(HASH_RE, "%23").replace(AMPERSAND_RE, "%26").replace(ENC_BACKTICK_RE, "`").replace(ENC_CURLY_OPEN_RE, "{").replace(ENC_CURLY_CLOSE_RE, "}").replace(ENC_CARET_RE, "^");
}

function encodeQueryKey(text) {
  return encodeQueryValue(text).replace(EQUAL_RE, "%3D");
}

function encodePath(text) {
  return encode(text).replace(HASH_RE, "%23").replace(IM_RE, "%3F").replace(ENC_ENC_SLASH_RE, "%2F").replace(AMPERSAND_RE, "%26").replace(PLUS_RE, "%2B");
}

function encodeParam(text) {
  return encodePath(text).replace(SLASH_RE, "%2F");
}

function decode() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  try {
    return decodeURIComponent("" + text);
  } catch (_err) {
    return "" + text;
  }
}

function decodePath(text) {
  return decode(text.replace(ENC_SLASH_RE, "%252F"));
}

function decodeQueryValue(text) {
  return decode(text.replace(PLUS_RE, " "));
}

function encodeHost() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return toASCII(name);
}

function parseQuery() {
  var paramsStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var obj = {};

  if (paramsStr[0] === "?") {
    paramsStr = paramsStr.substr(1);
  }

  var _iterator4 = _createForOfIteratorHelper(paramsStr.split("&")),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var param = _step4.value;

      var _s = param.match(/([^=]+)=?(.*)/) || [];

      if (_s.length < 2) {
        continue;
      }

      var key = decode(_s[1]);

      if (key === "__proto__" || key === "constructor") {
        continue;
      }

      var value = decodeQueryValue(_s[2] || "");

      if (obj[key]) {
        if (Array.isArray(obj[key])) {
          obj[key].push(value);
        } else {
          obj[key] = [obj[key], value];
        }
      } else {
        obj[key] = value;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return obj;
}

function encodeQueryItem(key, val) {
  if (!val) {
    return encodeQueryKey(key);
  }

  if (Array.isArray(val)) {
    return val.map(function (_val) {
      return "".concat(encodeQueryKey(key), "=").concat(encodeQueryValue(_val));
    }).join("&");
  }

  return "".concat(encodeQueryKey(key), "=").concat(encodeQueryValue(val));
}

function stringifyQuery(query) {
  return Object.keys(query).map(function (k) {
    return encodeQueryItem(k, query[k]);
  }).join("&");
}

var $URL = /*#__PURE__*/function () {
  function $URL() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    _classCallCheck(this, $URL);

    this.query = {};

    if (typeof input !== "string") {
      throw new TypeError("URL input should be string received ".concat(typeof input, " (").concat(input, ")"));
    }

    var parsed = parseURL(input);
    this.protocol = decode(parsed.protocol);
    this.host = decode(parsed.host);
    this.auth = decode(parsed.auth);
    this.pathname = decodePath(parsed.pathname);
    this.query = parseQuery(parsed.search);
    this.hash = decode(parsed.hash);
  }

  _createClass($URL, [{
    key: "hostname",
    get: function get() {
      return parseHost(this.host).hostname;
    }
  }, {
    key: "port",
    get: function get() {
      return parseHost(this.host).port || "";
    }
  }, {
    key: "username",
    get: function get() {
      return parseAuth(this.auth).username;
    }
  }, {
    key: "password",
    get: function get() {
      return parseAuth(this.auth).password || "";
    }
  }, {
    key: "hasProtocol",
    get: function get() {
      return this.protocol.length;
    }
  }, {
    key: "isAbsolute",
    get: function get() {
      return this.hasProtocol || this.pathname[0] === "/";
    }
  }, {
    key: "search",
    get: function get() {
      var q = stringifyQuery(this.query);
      return q.length ? "?" + q : "";
    }
  }, {
    key: "searchParams",
    get: function get() {
      var _this = this;

      var p = new URLSearchParams();

      var _loop = function _loop(name) {
        var value = _this.query[name];

        if (Array.isArray(value)) {
          value.forEach(function (v) {
            return p.append(name, v);
          });
        } else {
          p.append(name, value || "");
        }
      };

      for (var name in this.query) {
        _loop(name);
      }

      return p;
    }
  }, {
    key: "origin",
    get: function get() {
      return (this.protocol ? this.protocol + "//" : "") + encodeHost(this.host);
    }
  }, {
    key: "fullpath",
    get: function get() {
      return encodePath(this.pathname) + this.search + encodeHash(this.hash);
    }
  }, {
    key: "encodedAuth",
    get: function get() {
      if (!this.auth) {
        return "";
      }

      var _parseAuth = parseAuth(this.auth),
          username = _parseAuth.username,
          password = _parseAuth.password;

      return encodeURIComponent(username) + (password ? ":" + encodeURIComponent(password) : "");
    }
  }, {
    key: "href",
    get: function get() {
      var auth = this.encodedAuth;
      var originWithAuth = (this.protocol ? this.protocol + "//" : "") + (auth ? auth + "@" : "") + encodeHost(this.host);
      return this.hasProtocol && this.isAbsolute ? originWithAuth + this.fullpath : this.fullpath;
    }
  }, {
    key: "append",
    value: function append(url) {
      if (url.hasProtocol) {
        throw new Error("Cannot append a URL with protocol");
      }

      Object.assign(this.query, url.query);

      if (url.pathname) {
        this.pathname = withTrailingSlash(this.pathname) + withoutLeadingSlash(url.pathname);
      }

      if (url.hash) {
        this.hash = url.hash;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.href;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.href;
    }
  }]);

  return $URL;
}();

function isRelative(inputStr) {
  return ["./", "../"].some(function (str) {
    return inputStr.startsWith(str);
  });
}

function hasProtocol(inputStr) {
  var acceptProtocolRelative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /^\w+:\/\/.+/.test(inputStr) || acceptProtocolRelative && /^\/\/[^/]+/.test(inputStr);
}

var TRAILING_SLASH_RE = /\/$|\/\?/;

function hasTrailingSlash() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!queryParams) {
    return input.endsWith("/");
  }

  return TRAILING_SLASH_RE.test(input);
}

function withoutTrailingSlash() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!queryParams) {
    return (hasTrailingSlash(input) ? input.slice(0, -1) : input) || "/";
  }

  if (!hasTrailingSlash(input, true)) {
    return input || "/";
  }

  var _input$split = input.split("?"),
      _input$split2 = _toArray(_input$split),
      s0 = _input$split2[0],
      s = _input$split2.slice(1);

  return (s0.slice(0, -1) || "/") + (s.length ? "?".concat(s.join("?")) : "");
}

function withTrailingSlash() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!queryParams) {
    return input.endsWith("/") ? input : input + "/";
  }

  if (hasTrailingSlash(input, true)) {
    return input || "/";
  }

  var _input$split3 = input.split("?"),
      _input$split4 = _toArray(_input$split3),
      s0 = _input$split4[0],
      s = _input$split4.slice(1);

  return s0 + "/" + (s.length ? "?".concat(s.join("?")) : "");
}

function hasLeadingSlash() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return input.startsWith("/");
}

function withoutLeadingSlash() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return (hasLeadingSlash(input) ? input.substr(1) : input) || "/";
}

function withLeadingSlash() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return hasLeadingSlash(input) ? input : "/" + input;
}

function cleanDoubleSlashes() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return input.split("://").map(function (str) {
    return str.replace(/\/{2,}/g, "/");
  }).join("://");
}

function withBase(input, base) {
  if (isEmptyURL(base)) {
    return input;
  }

  var _base = withoutTrailingSlash(base);

  if (input.startsWith(_base)) {
    return input;
  }

  return joinURL(_base, input);
}

function withoutBase(input, base) {
  if (isEmptyURL(base)) {
    return input;
  }

  var _base = withoutTrailingSlash(base);

  if (input.startsWith(_base)) {
    return input.substr(_base.length) || "/";
  }

  return input;
}

function withQuery(input, query) {
  var parsed = parseURL(input);

  var mergedQuery = _objectSpread(_objectSpread({}, parseQuery(parsed.search)), query);

  parsed.search = stringifyQuery(mergedQuery);
  return stringifyParsedURL(parsed);
}

function getQuery(input) {
  return parseQuery(parseURL(input).search);
}

function isEmptyURL(url) {
  return !url || url === "/";
}

function isNonEmptyURL(url) {
  return url && url !== "/";
}

function joinURL(base) {
  var url = base || "";

  for (var _len = arguments.length, input = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    input[_key - 1] = arguments[_key];
  }

  var _iterator5 = _createForOfIteratorHelper(input.filter(isNonEmptyURL)),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var i = _step5.value;
      url = url ? withTrailingSlash(url) + withoutLeadingSlash(i) : i;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return url;
}

function createURL(input) {
  return new $URL(input);
}

function normalizeURL(input) {
  return createURL(input).toString();
}

function resolveURL(base) {
  var url = createURL(base);

  for (var _len2 = arguments.length, input = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    input[_key2 - 1] = arguments[_key2];
  }

  var _iterator6 = _createForOfIteratorHelper(input.filter(isNonEmptyURL)),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var i = _step6.value;
      url.append(createURL(i));
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return url.toString();
}

function isSamePath(p1, p2) {
  return decode(withoutTrailingSlash(p1)) === decode(withoutTrailingSlash(p2));
}

function parseURL() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var defaultProto = arguments.length > 1 ? arguments[1] : undefined;

  if (!hasProtocol(input, true)) {
    return defaultProto ? parseURL(defaultProto + input) : parsePath(input);
  }

  var _splice = (input.replace(/\\/g, "/").match(/([^:/]+:)?\/\/([^/@]+@)?(.*)/) || []).splice(1),
      _splice2 = _slicedToArray(_splice, 3),
      _splice2$ = _splice2[0],
      protocol = _splice2$ === void 0 ? "" : _splice2$,
      auth = _splice2[1],
      hostAndPath = _splice2[2];

  var _splice3 = (hostAndPath.match(/([^/?#]*)(.*)?/) || []).splice(1),
      _splice4 = _slicedToArray(_splice3, 2),
      _splice4$ = _splice4[0],
      host = _splice4$ === void 0 ? "" : _splice4$,
      _splice4$2 = _splice4[1],
      path = _splice4$2 === void 0 ? "" : _splice4$2;

  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return {
    protocol: protocol,
    auth: auth ? auth.substr(0, auth.length - 1) : "",
    host: host,
    pathname: pathname,
    search: search,
    hash: hash
  };
}

function parsePath() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var _splice5 = (input.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1),
      _splice6 = _slicedToArray(_splice5, 3),
      _splice6$ = _splice6[0],
      pathname = _splice6$ === void 0 ? "" : _splice6$,
      _splice6$2 = _splice6[1],
      search = _splice6$2 === void 0 ? "" : _splice6$2,
      _splice6$3 = _splice6[2],
      hash = _splice6$3 === void 0 ? "" : _splice6$3;

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

function parseAuth() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var _input$split5 = input.split(":"),
      _input$split6 = _slicedToArray(_input$split5, 2),
      username = _input$split6[0],
      password = _input$split6[1];

  return {
    username: decode(username),
    password: decode(password)
  };
}

function parseHost() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var _splice7 = (input.match(/([^/]*)(:0-9+)?/) || []).splice(1),
      _splice8 = _slicedToArray(_splice7, 2),
      hostname = _splice8[0],
      port = _splice8[1];

  return {
    hostname: decode(hostname),
    port: port
  };
}

function stringifyParsedURL(parsed) {
  var fullpath = parsed.pathname + (parsed.search ? (parsed.search.startsWith("?") ? "" : "?") + parsed.search : "") + parsed.hash;

  if (!parsed.protocol) {
    return fullpath;
  }

  return parsed.protocol + "//" + (parsed.auth ? parsed.auth + "@" : "") + parsed.host + fullpath;
}

export { $URL, cleanDoubleSlashes, createURL, decode, decodePath, decodeQueryValue, encode, encodeHash, encodeHost, encodeParam, encodePath, encodeQueryItem, encodeQueryKey, encodeQueryValue, getQuery, hasLeadingSlash, hasProtocol, hasTrailingSlash, isEmptyURL, isNonEmptyURL, isRelative, isSamePath, joinURL, normalizeURL, parseAuth, parseHost, parsePath, parseQuery, parseURL, resolveURL, stringifyParsedURL, stringifyQuery, withBase, withLeadingSlash, withQuery, withTrailingSlash, withoutBase, withoutLeadingSlash, withoutTrailingSlash };